import { render, staticRenderFns } from "./IosSafariTabBarBackgroundBar.vue?vue&type=template&id=1f0e4264&scoped=true&"
var script = {}
import style0 from "./IosSafariTabBarBackgroundBar.vue?vue&type=style&index=0&id=1f0e4264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0e4264",
  null
  
)

export default component.exports